import React from 'react';
import { Message, Icon, Container, Divider } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
const Loading = () => {
    return(
        <Container style={{ paddingTop: '80px', paddingLeft: '20px' }}>
            <Divider hidden/>   
            <Message icon info>
            <Icon name='circle notched' loading />
                <Message.Content>
                    <Message.Header><FormattedMessage id="message.hold" /></Message.Header>
                    <FormattedMessage id="message.waitingInfo" />
                </Message.Content>
            </Message>
        </Container>
    )
};
export default Loading


// WEBPACK FOOTER //
// ./src/components/loading-component.js